const subscriptionIT = {
    "view": {
        "table": {
            "title": "Il tuo abbonamento",
            "column": {
                "subscriptionTier": "Livello di abbonamento",
                "startDate": "Data di inizio",
                "currentPeriodStart": "Inizio periodo attuale",
                "currentPeriodEnd": "Fine periodo attuale",
                "autoRenewal": "Rinnovo automatico",
                "status": "Stato",
                "action": "Azione"
            },
            "label": {
                "status_active": "Attivo",
                "status_incomplete": "Incompleto",
                "status_incomplete_expired": "Incompleto scaduto",
                "status_unpaid": "Non pagato",
                "status_past_due": "Scaduto",
                "status_cancelled": "Annullato",
                "status_expired": "Scaduto"
            },
            "actionDropdown": {
                "label": {
                    "action": "Azione"
                },
                "button": {
                    "enableAutoRenewal": "Abilita rinnovo automatico",
                    "upgradeSubscription": "Aggiorna abbonamento",
                    "cancelSubscription": "Annulla abbonamento",
                    "resumeSubscription": "Riprendi abbonamento",
                    "retryPayment": "Riprova pagamento"
                },
                "message": {
                    "successSubscripionResumed": "Il tuo abbonamento è stato ripreso, il tuo account verrà aggiornato a breve!",
                    "successSubscripionCancelled": "Il tuo abbonamento è stato impostato per essere annullato alla fine del periodo!",
                    "successSubscripionAutoRenewalEnabled": "Il tuo abbonamento è stato impostato per essere rinnovato automaticamente alla fine del periodo!",
                    "activeSubscription": "Hai già un abbonamento attivo",
                    "incompleteSubscription": "Hai un abbonamento che è Incompleto."
                }
            },
            "modal": {
                "button": {
                    "cancel": "Annulla",
                    "enableAutoRenewal": "Abilita rinnovo automatico",
                    "cancelSubscription": "Annulla abbonamento"
                }
            }
        },
        "modal": {
            "enableAutoRenewal": {
                "header": "Abilita rinnovo automatico",
                "body": "Sei sicuro di voler abilitare il rinnovo automatico per il tuo abbonamento?"
            },
            "cancel": {
                "header": "Annulla abbonamento",
                "body": "Sei sicuro di voler annullare il tuo abbonamento?"
            },
            "resume": {
                "header": "Riprendi abbonamento",
                "body": {
                    "description": "Sei sicuro di voler riprendere l'abbonamento?",
                    "note": "<strong>Nota:</strong> Verrà applicato il prezzo più recente dell'abbonamento!"
                },
                "button": {
                    "cancel": "Annulla",
                    "resume": "Riprendi"
                },
                "message": {
                    "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
                }
            },
            "retryPayment": {
                "header": "Riprova pagamento abbonamento",
                "body": {
                    "description": "Sei sicuro di voler riprovare il pagamento per l'abbonamento?",
                    "note": "<strong>Nota:</strong> Verrà applicato il prezzo più recente dell'abbonamento!"
                },
                "button": {
                    "cancel": "Annulla",
                    "retry": "Riprova"
                },
                "message": {
                    "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
                }
            }
        },
        "message": {
            "errorPaymentFailed": "Il pagamento dell'abbonamento non è riuscito, riprova più tardi!",
            "errorCardExpired": "La tua carta è scaduta. Si prega di aggiungere un <1>metodo di pagamento</1> valido e riprovare il pagamento.",
            "errorNoPaymentMethod": "Non hai aggiunto alcun <1>metodo di pagamento</1> al tuo profilo. Si prega di aggiungere un <3>metodo di pagamento</3> valido e riprovare il pagamento.",
            "moduleNoAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni."
        }
    },
    "subscriptionTiers": {
        "form": {
            "title": "Scegli il tuo piano",
            "button": {
                "startNow": "Inizia ora"
            }
        },
        "message": {
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
        }
    },
    "upgrade": {
        "form": {
            "title": "Aggiorna il tuo abbonamento",
            "button": {
                "upgrade": "Aggiorna",
                "currentPlan": "Piano attuale"
            }
        },
        "modal": {
            "upgradeSubscription": {
                "header": "Aggiorna abbonamento",
                "body": {
                    "description": "Sei sicuro di voler aggiornare il tuo piano di abbonamento a <strong>{{newTierName}}</strong>.",
                    "note": "<strong>Nota: Il periodo di fatturazione dell'abbonamento rimarrà invariato e ti verrà addebitato solo l'importo escluso quanto già pagato per il piano esistente.</strong>"
                },
                "button": {
                    "cancel": "Annulla",
                    "confirm": "Conferma"
                }
            }
        },
        "message": {
            "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!",
            "moduleNoAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni."
        }
    },
    "confirmModal": {
        "header": "Conferma le tue informazioni",
        "body": {
            "form": {
                "label": {
                    "firstName": "Nome",
                    "lastName": "Cognome",
                    "country": "Paese di residenza",
                    "refundPolicyAgreement": "Procedendo, riconosco e accetto che questo pagamento è definitivo e non rimborsabile. <1>Politica di rimborso</1>",
                },
                "help_text": {
                    "firstName": "Conferma che questo è il tuo nome legale.",
                    "lastName": "Conferma che questo è il tuo cognome legale.",
                    "country": "Specifica il tuo attuale paese di residenza."
                },
                "message": {
                    "error": "Si è verificato un errore durante la creazione dell'abbonamento!",
                    "note": "Nota: L'accuratezza delle informazioni fornite qui è essenziale per i passaggi successivi. Assicurati che tutte le informazioni siano fornite in modo accurato e veritiero."
                }
            }
        },
        "button": {
            "cancel": "Annulla",
            "confirm": "Conferma"
        }
    },
    "upgradeFailure": {
        "view": {
            "title": "Aggiornamento abbonamento fallito :(",
            "description": "Si è verificato un problema nell'aggiornamento del tuo abbonamento. Riprova più tardi!",
            "button": {
                "returnToDashboard": "Torna alla Dashboard"
            }
        }
    },
    "upgradeSuccess": {
        "view": {
            "title": "Abbonamento aggiornato :)",
            "description": "Hai aggiornato con successo il tuo abbonamento, il tuo account verrà aggiornato a breve!",
            "button": {
                "returnToDashboard": "Torna alla Dashboard"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transazione annullata :(",
            "description": "La transazione è stata annullata... Riprova più tardi!",
            "button": {
                "returnToDashboard": "Torna alla Dashboard"
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transazione riuscita :)",
            "description": "Hai confermato con successo il tuo abbonamento, il tuo account verrà aggiornato a breve!",
            "button": {
                "returnToDashboard": "Torna alla Dashboard"
            }
        }
    }
};

export default subscriptionIT;